export default {
	browserTabNotification: 2000,
	debounce: 150,
	shortDelay: 1500,
	second: 1000,
	initTimeout: 1000,
	serverTimeout: 10000,
};
